import React from "react";
import { DEFAULT_IMAGE_AVATAR } from "utils/constants";
import { cn } from "utils/helpers";
import FallbackImage from "components/FallbackImage/FallbackImage";
import SkeletonBase from "newui/components/Skeleton";

type ProfileAvatarProps = {
	imagePath: string;
	isLoading: boolean;
	className?: string;
	defaultImage?: string;
	handleClick: () => void;
};

export const ProfileAvatar: React.FC<ProfileAvatarProps> = ({
	imagePath,
	className,
	defaultImage,
	isLoading = false,
}) => {
	const defaultImageFor = {
		user: "/img/user-01.svg",
		company: DEFAULT_IMAGE_AVATAR,
	};
	const imageSrc = imagePath ? imagePath : defaultImageFor[defaultImage];

	return (
		<div
			className={cn(
				`align-center flex items-center justify-center overflow-hidden rounded-full bg-white`,
				className
			)}
		>
			{isLoading ? (
				<SkeletonBase />
			) : (
				<FallbackImage
					src={imageSrc}
					className={`h-full w-full object-contain p-2`}
					alt=""
					fallbackSrc={DEFAULT_IMAGE_AVATAR}
				/>
			)}
		</div>
	);
};
